import { render } from "./modal_autoriserserveur.vue?vue&type=template&id=1c1200e9&scoped=true"
import script from "./modal_autoriserserveur.vue?vue&type=script&lang=js"
export * from "./modal_autoriserserveur.vue?vue&type=script&lang=js"

import "./modal_autoriserserveur.vue?vue&type=style&index=0&id=1c1200e9&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c1200e9"]])

export default __exports__